/* eslint-disable object-curly-newline */
import update from 'immutability-helper';
import naturalCompare from 'string-natural-compare';
import { indexById } from '../indexById/indexById';
import { get as getId } from '../localId/localId';

export const ADD_LOCAL_COST_CODE = 'ADD_LOCAL_COST_CODE';
export const REMOVE_LOCAL_COST_CODE = 'REMOVE_LOCAL_COST_CODE';
export const API_LOAD_COST_CODES = 'API_LOAD_COST_CODES';
export const API_REMOVE_COST_CODE = 'API_REMOVE_COST_CODE';
export const API_CREATE_COST_CODE = 'API_CREATE_COST_CODE';
export const API_UPDATE_COST_CODE = 'API_UPDATE_COST_CODE';

const API_LOAD_COST_CODES_FAILED = 'API_LOAD_COST_CODES_FAILED';
const API_LOAD_COST_CODES_LOADING = 'API_LOAD_COST_CODES_LOADING';
const API_LOAD_COST_CODES_LOADED = 'API_LOAD_COST_CODES_LOADED';
const API_REMOVE_COST_CODE_FAILED = 'API_REMOVE_COST_CODE_FAILED';
const API_REMOVE_COST_CODE_LOADING = 'API_REMOVE_COST_CODE_LOADING';
const API_REMOVE_COST_CODE_SUCCESS = 'API_REMOVE_COST_CODE_SUCCESS';
const API_CREATE_COST_CODE_FAILED = 'API_CREATE_COST_CODE_FAILED';
const API_CREATE_COST_CODE_LOADING = 'API_CREATE_COST_CODE_LOADING';
const API_CREATE_COST_CODE_SUCCESS = 'API_CREATE_COST_CODE_SUCCESS';
const API_UPDATE_COST_CODE_FAILED = 'API_UPDATE_COST_CODE_FAILED';
const API_UPDATE_COST_CODE_LOADING = 'API_UPDATE_COST_CODE_LOADING';
const API_UPDATE_COST_CODE_SUCCESS = 'API_UPDATE_COST_CODE_SUCCESS';

const defaultState = { costCodes: [], loading: false };
const emptyCostCode = () => ({ id: getId(), name: '', isRemoving: false });
const mapDefaults = costCode => ({ ...emptyCostCode(), ...costCode });

export const reducer = (state = defaultState, { type, response, id, replaceId, resource }) => {
  switch (type) {
    case API_LOAD_COST_CODES_LOADED:
      return update(state, {
        loading: { $set: false },
        costCodes: { $set: response.map(mapDefaults) },
      });
    case API_LOAD_COST_CODES_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_COST_CODES_FAILED:
      return update(state, { loading: { $set: false } });
    case ADD_LOCAL_COST_CODE:
      return update(state, { costCodes: { $push: [emptyCostCode()] } });
    case API_REMOVE_COST_CODE_SUCCESS:
    case REMOVE_LOCAL_COST_CODE:
      return update(state, { costCodes: { $splice: [[indexById(id, state.costCodes), 1]] } });
    case API_REMOVE_COST_CODE_FAILED:
      return update(state, { costCodes: { [indexById(id, state.costCodes)]: { removing: { $set: false } } } });
    case API_REMOVE_COST_CODE_LOADING:
      return update(state, { costCodes: { [indexById(id, state.costCodes)]: { removing: { $set: true } } } });
    case API_CREATE_COST_CODE_FAILED:
      return update(state, { costCodes: { [indexById(resource.id, state.costCodes)]: { saving: { $set: false } } } });
    case API_CREATE_COST_CODE_LOADING:
      return update(state, { costCodes: { [indexById(resource.id, state.costCodes)]: { saving: { $set: true } } } });
    case API_CREATE_COST_CODE_SUCCESS:
      return update(state, { costCodes: { $splice: [[indexById(replaceId, state.costCodes), 1, response]] } });
    default:
      return state;
  }
};

export const costCodes = (state, categoryId) => {
  let costCodes = state.costCodes.costCodes;
  if(categoryId !== undefined && categoryId !== "") {
    costCodes = costCodes.filter((a) => a.cost_code_category_id === Number.parseInt(categoryId));
  }
  return costCodes.sort((a, b) => naturalCompare.caseInsensitive(a.name, b.name));
};

export const loading = state => state.costCodes.loading;
export const groupedCostCodes = state =>
  costCodes(state).reduce((newObject, object) => {
    const costCodeCategory = object.cost_code_category || { name: 'Other' };

    const index = newObject.findIndex(o => o.label === costCodeCategory.name);
    const optionGroup = newObject[index]
      || { label: costCodeCategory.name, options: [] };

    optionGroup.options.push({ label: object.name, value: object.id });

    if (index > -1) update(newObject, { [index]: { $set: optionGroup } });
    else newObject.push(optionGroup);

    return newObject;
  }, []).sort((a, b) => naturalCompare.caseInsensitive(a.label, b.label));

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/costCode/costCode.reducer.js